import React, { useState } from 'react'
import { FormGroup } from 'reactstrap'
import SelectCheckbox from '../SelectCheckbox'
import 'react-dates/initialize'
import moment from 'moment'
import { I18n } from 'react-redux-i18n'
import { connect } from 'react-redux'
import { SelectDateRangePicker } from 'components/Form'

const Option = ({ data, onSelected, label, company, defaultValues = [] }) => {
  const createdFromChosen = label === 'createdAt' && defaultValues.length ? moment(defaultValues[0]) : null
  const createdUntilChosen = label === 'createdAt' && defaultValues.length ? moment(defaultValues[1]) : null
  const updatedFromChosen = label === 'updatedAt' && defaultValues.length ? moment(defaultValues[0]) : null
  const updatedUntilChosen = label === 'updatedAt' && defaultValues.length ? moment(defaultValues[1]) : null

  const [createdFrom, setCreatedFrom] = useState(createdFromChosen)
  const [createdUntil, setCreatedUntil] = useState(createdUntilChosen)
  const [updatedFrom, setUpdatedFrom] = useState(updatedFromChosen)
  const [updatedUntil, setUpdatedUntil] = useState(updatedUntilChosen)

  // const filters = [{ value: 'all', label: 'all' }].concat(
  //   data.map((el) => ({
  //     value: el.value,
  //     label: label === 'states' ? I18n.t(`states_${el.label}`) : el.label,
  //   }))
  // )

  const filters = data.map((el) => ({
    value: el.value,
    label: label === 'states' ? I18n.t(`states_${el.label}`) : el.label,
  }))
  

  const onChangeDate = (label, startDate, endDate) => {
    const _startDate = startDate ? moment(startDate).format('YYYY-MM-DD') : null
    const _endDate = endDate ? moment(endDate).format('YYYY-MM-DD') : null
    if (label === 'createdAt') {
      setCreatedFrom(_startDate)
      setCreatedUntil(_endDate)
    } else {
      setUpdatedFrom(_startDate)
      setUpdatedUntil(_endDate)
    }

    const dates = [
      { value: _startDate, label: _startDate },
      { value: _endDate, label: _endDate },
    ]
    onSelected({ label: label, data: dates })
  }

  return (
    <FormGroup inline style={{ padding: '0 5px' }}>
      {/* <Label style={{ fontSize: '12px' }}>{I18n.t(`campaigns_${label}`)}</Label> */}
      {label === 'createdAt' && (
        <div style={{ width: '225px' }}>
          <SelectDateRangePicker
            id={label}
            label={I18n.t(`campaigns_${label}`)}
            startDate={createdFrom && moment(createdFrom)}
            startDateId='startDateC'
            endDate={createdUntil && moment(createdUntil)}
            endDateId={'endDateC'}
            onDatesChange={onChangeDate}
            minDate={company.activationStartAt}
            classNameWrapper={'filters-options-date'}
          />
        </div>
      )}
      {label === 'updatedAt' && (
        <div style={{ width: '225px' }}>
          <SelectDateRangePicker
            id={label}
            label={I18n.t(`campaigns_${label}`)}
            startDate={updatedFrom && moment(updatedFrom)}
            startDateId='startDateU'
            endDate={updatedUntil && moment(updatedUntil)}
            endDateId={'endDateU'}
            onDatesChange={onChangeDate}
            minDate={company.activationStartAt}
            classNameWrapper={'filters-options-date'}
          />
        </div>
      )}
      {label !== 'updatedAt' && label !== 'createdAt' && (
        <div style={{ width: '150px' }}>
          <SelectCheckbox
            label={I18n.t(label === 'categories' ? 'dashboard_labels' : `campaigns_${label}`)}
            isSearchable={false}
            options={filters}
            onChangeCallback={(value) => onSelected({ label, data: value })}
            placeholder={I18n.t(
              label === 'states'
                ? 'dashboard_state'
                : label === 'categories'
                  ? 'dashboard_labels'
                  : `campaigns_${label}`
            )}
            classNameWrapper={'filters-options'}
            defaultValue={defaultValues}
          />
        </div>
      )}
    </FormGroup>
  )
}

export default connect((state) => ({
  company: state.companies,
}))(Option)
